export const EventKeys = {
    commentHighlightRange: 'commentHighlightRange',
    commentSelectFromChart: 'commentSelectFromChart',
    commentsList: 'commentsList',
    flyoutClose: 'flyoutClose',
    blockOutsideCLick: 'blockOutsideCLick'
};

export type EventKey = keyof typeof EventKeys;
